// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"817":"1e23c465","845":"28db70aa"}[chunkId] + ".chunk.js";
};